/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';

import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDefyById, defyCancelSubcription } from '../../../../modules/sport/actions/reducerDefy';
import Loading from '../../../../common/loading/Loading';
import { format } from 'date-fns';
import Copy from '../../../../common/components/sections/Copy';
import MsjSuccess from '../../../../common/components/sections/MsjSuccessDefy';
import { attributesBySport } from '../../../../common/data/attributes';

import { useAuth } from '../../../../context/auth-context';
import Defy from '../../../../common/components/sections/Defy';
import { ITeam } from '../../../../modules/sport/interfaces/profile';
import { teamProfileGet } from '../../../../modules/sport/actions/reducerTeam';
import FormCreateTeam from '../../../../common/components/sections/FormCreateTeam';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Challenge = (): JSX.Element => {
    const auth = useAuth();
    const router = useHistory();
    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const team = query.get('team');
    const challengeId = query.get('challengeId');
    const teamIdRankingFilter = query.get('teamIdRankingFilter');
    const teamNameRankingFilter = query.get('teamNameRankingFilter');
    const teamLogoRankingFilter = query.get('teamLogoRankingFilter');
    const selectDefy = (state: any) => state.defy;
    const defy = useSelector(selectDefy);
    const selectTeam = (state: any) => state.team;
    const teamSport = useSelector(selectTeam);
    const [openModalTeam, setOpenModalTeam] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [dataTeamOri, setdataTeamOri] = useState<ITeam>();
    const [detDefy, setDetDefy] = useState<any | null>(null);
    const [cancelSuscription, setCancelSuscription] = useState<string>('inactive');
    const [statusCancel, setStatusCancel] = useState(false);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const week = query.get('week');
    const region = query.get('region');
    const commune = query.get('commune');
    const [timeDefy, setTimeDefy] = useState(false);
    const mydate = new Date();
    const role = auth?.user?.role || 'PLAYER';
    const linkBase = process.env.REACT_APP_URL_DASHBOARD;
    const [linkDashboard, setLinkDashboard] = useState<string>();
    const [errorDefy, setErrorDefy] = useState<string>('');
    const pathnameDefys = `/${sport}/desafiar/equipos/filter`;
    const pathnameAll = window.location.pathname + useLocation().search;
    const history = useHistory();

    const [breads, setBreads] = useState([
        {
            key: 'desafiar',
            name: 'Desafíar | Buscar',
            url: `/desafiar`,
            add: true,
        },
        {
            key: 'equipos',
            name: 'Equipos',
            url: pathnameDefys,
            add: false,
        },
        {
            key: 'desafío',
            name: 'Desafío',
            url: pathnameAll,
            add: false,
        },
    ]);

    useEffect(() => {
        setErrorDefy('');
        dispatch(teamProfileGet(sport));
    }, [auth]);

    // Obtener la información del partido
    useEffect(() => {
        setDetDefy(null);
        if (challengeId) {
            dispatch(fetchDefyById(challengeId, auth.isLoggedIn, team, 'challengeDetail'));
        }
    }, [challengeId]);

    useEffect(() => {
        if (region || commune) {
            const pathQuery = `?region=${region}&commune=${commune}&week=${week}`;

            const pathnameDefys = `/${sport}/desafiar/equipos/filter${(region || commune) && pathQuery}`;

            setBreads([
                {
                    key: 'desafiar',
                    name: 'Desafíar | Buscar',
                    url: `/desafiar`,
                    add: true,
                },
                {
                    key: 'equipos',
                    name: 'Equipos',
                    url: pathnameDefys,
                    add: false,
                },
                {
                    key: 'desafío',
                    name: 'Desafío',
                    url: pathnameAll,
                    add: false,
                },
            ]);
        }
    }, [week, region, commune]);

    useEffect(() => {
        if (defy) {
            if (defy.error) {
                // console.log('aqui error', defy.error);
                setErrorDefy('Error al obtener los recursos para este desafío');
            } else {
                if (defy.data && defy.data.data && defy.data.statusCode === 'CHALLENGES_BY_ID') {
                    //console.log(defy.data.data);
                    setStatusCancel(false);
                    const newDefy = defy.data.data;
                    if (
                        (teamIdRankingFilter === '' && teamNameRankingFilter === '') ||
                        (teamIdRankingFilter === null && teamNameRankingFilter === null)
                    ) {
                        setDetDefy(newDefy);
                    } else {
                        console.log('****entro filtro ranking', {
                            newDefy,
                            teamIdRankingFilter,
                            teamNameRankingFilter,
                        });
                        if (newDefy.challengedTeamId == null) {
                            setDetDefy({
                                ...newDefy,
                                challengedTeam: {
                                    id: teamIdRankingFilter,
                                    name: teamNameRankingFilter,
                                    logo: teamLogoRankingFilter,
                                },
                            });
                        } else {
                            setDetDefy(newDefy);
                        }
                    }
                }
                if (
                    defy.data &&
                    defy.data.data &&
                    (defy.data.statusCode === 'CHALLENGES_CANCELED' ||
                        defy.data.statusCode === 'CHALLENGES_REJECTED_SUCCESS')
                ) {
                    setStatusCancel(true);
                }
            }
        }
    }, [defy]);

    useEffect(() => {
        if (detDefy && detDefy.reservation && detDefy.reservation.start) {
            const capacityTeam =
                detDefy.reservation.field?.capacity > 0 ? Math.round(detDefy.reservation.field?.capacity / 2) : '';
            const capacity = ` ${capacityTeam}x${capacityTeam} `;
            setLinkDashboard(`${linkBase}defy/${detDefy?.id}`);
            //console.log({ detDefy });
            const regionId = detDefy.reservation.field?.club?.regionId;
            const countyId = detDefy.reservation.field?.club?.countyId;

            if (!(week || region || commune)) {
                const pathnameDefys = `/${sport}/desafiar/equipos/filter?region=${regionId}&commune=${countyId}&onlyAvailable=`;

                setBreads([
                    {
                        key: 'desafiar',
                        name: 'Desafíar | Buscar',
                        url: `/desafiar`,
                        add: true,
                    },
                    {
                        key: 'equipos',
                        name: 'Equipos',
                        url: pathnameDefys,
                        add: false,
                    },
                    {
                        key: 'desafío',
                        name: 'Desafío',
                        url: pathnameAll,
                        add: false,
                    },
                ]);
            }
            setDateMatch({
                start: format(new Date(detDefy.reservation?.start), "H':'mm"),
                date: format(new Date(detDefy.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detDefy.reservation.end), "H':'mm"),
                format: '',
                club: detDefy.reservation.field.club?.name || '',
            });
            const time: number = Date.parse(detDefy.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeDefy(true);
            } else {
                setTimeDefy(false);
            }
            if (detDefy.challengerTeam && detDefy.challengedTeam === null && capacity) {
                setTitle(`Partido ${capacity}`);
            }
            if (detDefy.challengedTeam && detDefy.challengerTeam && capacity) {
                setTitle(`Partido ${capacity}`);
            }
        }
    }, [detDefy]);

    const handlerNext = () => {
        if (detDefy) {
            const path = `/${sport}/desafiar/equipo/confirmar/filter`;
            const search = `?challengeId=${detDefy?.id}&team=${team}&teamIdRankingFilter=${
                teamIdRankingFilter || ''
            }&teamNameRankingFilter=${teamNameRankingFilter || ''}&teamLogoRankingFilter=${
                teamLogoRankingFilter || ''
            }`;
            router.push({
                pathname: path,
                search: search,
            });
        }
    };
    const handleCancel = (value) => {
        if (detDefy) {
            setCancelSuscription(value);
        } /* else if (detDefy) {
            setCancelSuscription(value);
        }*/
    };

    const handleNextPayment = () => {
        history.push(`/${sport}/desafiar/pago/filter?challengeId=${detDefy?.id}`);
    };

    const handleCancelSubcription = () => {
        dispatch(defyCancelSubcription(challengeId));
    };

    const subTitle = '';

    useEffect(() => {
        if (teamSport) {
            if (teamSport.error) {
                setErrorDefy('Error al obtener el Equipo del usuario');
            } else {
                if (teamSport.data && teamSport.data.data && teamSport.data.statusCode === 'USER_PROFILE_TEAM_GETED') {
                    const dataTeam = teamSport.data.data;
                    setdataTeamOri(dataTeam);
                    //aqui valido si updateTeamProfile viene en falso no tiene nombre de equipo, se activa el formulario para crearlo
                    if ((!detDefy?.challengedTeamId || !detDefy?.challengerTeamId) && !dataTeam.updatedTeamProfile) {
                        setOpenModalTeam(true);
                    } else {
                        setOpenModalTeam(false);
                    }
                }
            }
        }
    }, [teamSport]);

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside
                    attribute={attribute}
                    title={title}
                    subTitle={subTitle}
                    breads={breads}
                    activeIcon={false}
                >
                    {defy.isLoading ? (
                        <Loading />
                    ) : detDefy && !statusCancel && errorDefy === '' ? (
                        !openModalTeam ? (
                            <>
                                <Defy
                                    detDefy={detDefy}
                                    timeDefy={timeDefy}
                                    dateMatch={dateMatch}
                                    sport={sport}
                                    imageVs={attribute.icon.image}
                                    origin="index"
                                    teamAuth={teamSport?.data?.data || null}
                                    handlerNext={() => handlerNext()}
                                />
                                {!timeDefy &&
                                    teamSport?.data?.data?.id !== detDefy.challengedTeamId &&
                                    teamSport?.data?.data?.id !== detDefy.challengerTeamId &&
                                    // si es 1 === challenger, 2 === challenged
                                    (detDefy.challengerStatus !== 'ACCEPTED' ||
                                        detDefy.challengedStatus !== 'ACCEPTED') &&
                                    (detDefy.challengerTeamId == null || detDefy.challengedTeamId == null) &&
                                    detDefy.type === 'OPEN' && (
                                        <div className="container mx-auto  flex-col text-center pt-10 pb-5 space-x-8">
                                            <button
                                                className={`bg-sm-integrate  w-1/2 md:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handlerNext()}
                                                disabled={false}
                                            >
                                                Desafíar
                                            </button>
                                        </div>
                                    )}

                                <div className="flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    {((teamSport?.data?.data?.id === detDefy.challengedTeamId &&
                                        detDefy.challengedStatusPaid === 'PARTIAL_PAYMENT') ||
                                        (teamSport?.data?.data?.id === detDefy.challengerTeamId &&
                                            detDefy.challengerStatusPaid === 'PARTIAL_PAYMENT')) &&
                                        cancelSuscription === 'inactive' &&
                                        !timeDefy && (
                                            <button
                                                className={`bg-sm-integrate  w-1/2 md:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handleNextPayment()}
                                                disabled={!detDefy.challengerStatus ? true : false}
                                            >
                                                Completar Pago
                                            </button>
                                        )}
                                </div>
                                <Copy />
                                <div className="flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    {((teamSport?.data?.data?.id === detDefy.challengedTeamId &&
                                        detDefy.challengedStatusPaid === 'PENDING_PAYMENT') ||
                                        (teamSport?.data?.data?.id === detDefy.challengerTeamId &&
                                            detDefy.challengerStatusPaid === 'PENDING_PAYMENT')) &&
                                        cancelSuscription === 'inactive' && (
                                            <button
                                                className={`w-1/2 md:w-48  contact-button bg-sm-blue-primary  rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handleCancel('active')}
                                                disabled={!detDefy.challengerStatus ? true : false}
                                            >
                                                Cancelar Reserva
                                            </button>
                                        )}
                                </div>

                                <div className="flex-col text-center py-5  space-x-8">
                                    {role === 'ADMIN' && (
                                        <a
                                            className={`w-1/2 md:w-1/4 contact-button bg-sm-rent px-4 rounded-full text-white uppercase py-4 font-extrabold`}
                                            target="_blank"
                                            href={linkDashboard}
                                        >
                                            Ir al Dashboard de este Desafío
                                        </a>
                                    )}
                                </div>
                                {cancelSuscription && cancelSuscription === 'active' && (
                                    <div className="flex-col text-center pt-1 ">
                                        <p className="text-center text-2xl font-bold italic text-red-500 pt-4 pb-2">
                                            ¿Estás seguro que ya no deseas este desafío ?
                                        </p>
                                        {/*  <p className="text-center text-2xl font-bold italic text-red-500 pt-4 pb-4">
                                            No hay devolución de dinero en caso de cancelación.
                                        </p> */}
                                        <div className="flex space-x-8 text-center w-1/2 mx-auto justify-center items-center">
                                            <button
                                                className={`${'bg-green-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handleCancelSubcription()}
                                            >
                                                Si
                                            </button>
                                            <button
                                                className={`${'bg-red-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                                type="button"
                                                onClick={() => handleCancel('inactive')}
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <FormCreateTeam
                                setOpenModalTeam={setOpenModalTeam}
                                setdataTeamOri={setdataTeamOri}
                                sport={sport}
                                team={teamSport}
                            />
                        )
                    ) : (
                        <>
                            {errorDefy && (
                                <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                    <div className="w-full text-center content-center items-center">
                                        <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                            * {errorDefy}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {detDefy && statusCancel && (
                                <MsjSuccess>
                                    <>
                                        <p className="pt-5 text-center text-2xl font-bold italic"> Desafío cancelado</p>
                                        <p className="">_________________________</p>
                                        <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                            Tu Desafío fue cancelado
                                        </p>
                                    </>
                                </MsjSuccess>
                            )}
                        </>
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default Challenge;
